import type { BehaviorFunction } from "api/types/aba";

export const HYPOTHESIZED_FUNCTION_OPTIONS: Array<{ value: BehaviorFunction; label: string }> = [
  { value: "attention", label: "Attention" },
  { value: "escape", label: "Escape" },
  { value: "tangible", label: "Tangible" },
  { value: "sensory", label: "Automatic" },
];

export const HYPOTHESIZED_FUNCTION_LABELS: Record<BehaviorFunction, string> =
  HYPOTHESIZED_FUNCTION_OPTIONS.reduce(
    (acc, option) => {
      acc[option.value] = option.label;
      return acc;
    },
    {} as Record<BehaviorFunction, string>
  );
